<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          small
          elevation="0"
          color="primary"
          @click="openEmail()"
          class="pa-0"
          v-bind="attrs"
          v-on="on"
        >
          <span class="subtitle-1">Help</span>
          <v-icon size="16">mdi-help</v-icon>
        </v-btn>
      </template>
      <span>Contact Site Owner</span>
    </v-tooltip>
    <v-dialog v-model="sendEmailFlag" max-width="600">
      <v-card>
        <v-card-title>
          <v-row class="row-class">
            <v-col cols="12" sm="10" md="10">
              <span>Contact Us for Assistance</span>
            </v-col>
          </v-row>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :ripple="false"
                icon
                color="magenta"
                small
                v-bind="attrs"
                v-on="on"
                @click="sendEmailFlag = false"
              >
                <v-icon>mdi-close-box</v-icon>
              </v-btn>
            </template>
            <span> Close</span>
          </v-tooltip>
        </v-card-title>

        <v-form ref="emailForm" v-model="valid" lazy-validation>
          <v-card-text class="pt-5 pb-0">
            <div class="mb-2">
              <p>
                Thank you for using the Procurement Strategy Communication Tool.
                If you have any questions or need assistance with the
                application, please don't hesitate to reach out. Simply submit
                your inquiry, and the site owner will respond promptly. We
                appreciate your feedback and are here to help!
              </p>
            </div>

            <v-textarea
              rows="3"
              maxlength="300"
              v-model="additionalComments"
              class="no-bg-color custom-label-color"
              :rules="rules.help"
              required
            >
              <template v-slot:label>
                <span class="red-asterisk"> * </span>
                <span>Additional Comments: </span>
              </template>
            </v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="sendEmailFlag = false"
                  :ripple="false"
                  dark
                  color="blue"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span class="material-symbols-outlined"> arrow_back </span>
                </v-btn>
              </template>
              <span>Back</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="sendHelpEmail()"
                  :ripple="false"
                  color="green"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <span class="material-symbols-outlined">check</span>
                </v-btn>
              </template>
              <span>Send</span>
            </v-tooltip>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import requestsMixin from "../mixins/requests-mixin";
import appMixin from "../mixins/app-mixin";
import axios from "axios";
export default {
  mixins: [requestsMixin, appMixin],
  name: "Help",
  components: {},
  async mounted() {},
  computed: {},
  data() {
    return {
      sendEmailFlag: false,
      additionalComments: "",
      valid: true,
      rules: {
        help: [(v) => !!v || "Additional Comments is required"],
      },
    };
  },
  methods: {
    openEmail() {
      this.sendEmailFlag = !this.sendEmailFlag;
      this.$refs.emailForm.reset();
      this.emails = [];
    },
    async sendHelpEmail() {
      var ts = this;

      if (ts.$refs.emailForm.validate()) {
        let newData = {
          from: ts.$store.getters.getUserDetail.userEmail,
          subject: "Procurement Strategy Communication Tool - Help",
          body: ts.additionalComments,
        };

        await axios({
          method: "post",
          url: ts.settings.apiUrl + "/Email/HelpMail",
          data: newData,
        })
          .then(function (response) {            
            ts.sendEmailFlag = false;
          })
          .catch(function (error) {
            console.log("Error! Could not reach the API. " + error);
          });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.red-asterisk {
  color: red;
  font-size: larger;
}
</style>
